export abstract class ResponseMapper<I, O> {
  abstract fromResponse(param: I): O;
}
